import React from 'react';

import { RequestExceptionWithResponse } from '@eika-infrastruktur/request';
import { Button } from '@eika/button';
import { InfoCard } from '@eika/card';
import { RichIcon, RichIconTypes } from '@eika/rich-icon';

import ErrorCardWrapper from '../../../components/ErrorCardWrapper';
import { useTranslation } from '../../../translations';

interface Props {
    refresh: () => void;
    error: RequestExceptionWithResponse | null;
    noContent: { value: boolean; title: string };
}

const TransactionListStatus: React.FC<Props> = ({ noContent, error, refresh }) => {
    const translated = useTranslation().transactions;

    if (error) {
        return (
            <ErrorCardWrapper exception={error}>
                <Button onClick={refresh}>{translated.tryAgain}</Button>
            </ErrorCardWrapper>
        );
    }

    if (noContent.value) {
        return (
            <InfoCard skipBackground>
                <RichIcon type={RichIconTypes.BAAT_M_SOL} />
                <InfoCard.TitleH2>{noContent.title}</InfoCard.TitleH2>
            </InfoCard>
        );
    }

    return <></>;
};

export default TransactionListStatus;
